export default {
    namespaced: true,

    state: {
        layerState: []
    },

    actions: {
        initialize() {
            console.info('Maps module store initializing...')
            console.info('Maps module store initialized.')
        }
    }
}
